import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const salesOrderCountWidget: DashboardWidgetConfiguration = {
  widgetId: "sales.order-count",
  name: "Sales orders",
  description: "Distinct sales orders created in the selected period.",
  apps: [
    "appointments",
    "asset",
    "attendance",
    "configuration",
    "contracts",
    "crm",
    "document",
    "expenses",
    "field-service",
    "finance",
    "help-desk",
    "home",
    "hr",
    "integrations",
    "inventory",
    "invoicing",
    "maintanance",
    "manufacturing",
    "payroll",
    "point-of-sale",
    "procurement",
    "project",
    "recruitment",
    "rental",
    "sales",
    "schedule-planning",
    "subscriptions",
    "time-off",
    "timesheets",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "sales.analysis",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "order_id",
          as: "orders",
        },
      ],
    },
    subtextQuery: {
      version: 1,
      source: "sales.analysis",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "order_id",
          as: "waiting_payments",
        },
      ],
      where: {
        type: "condition",
        field: "status",
        operator: "eq",
        value: "sent",
      },
    },
  },
  inputs: {
    label: "Sales",
    subtext: "waiting payments",
    icon: "money",
    color: "primary",
  },
  dummyData: {
    value: 132,
    subtext: "12 waiting payments",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 3,
    defaultHeight: 1,
  },
};
